import { Content } from '@/domain/mitarbeiter/features/anlageassistent/components/Content';
import { MobileFooter } from '@/domain/mitarbeiter/features/anlageassistent/components/Footer';
import { MobileNavigation } from '@/domain/mitarbeiter/features/anlageassistent/components/NavigationWrapper';
import { AnlageassistentProgressbar } from '@/domain/mitarbeiter/features/anlageassistent/components/Progressbar';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentContext';

export function MobilePage() {
  const { ctx } = useAnlageassistentContext();
  const currentStep = ctx.state.steps[ctx.state.currentStepIndex];
  return (
    <div className="flex flex-col h-dvh">
      <MobileNavigation />
      {currentStep.type === 'step' && <AnlageassistentProgressbar />}
      <Content />
      <MobileFooter />
    </div>
  );
}
